/* Satisfy-layout product page: looping carousel, sticky info that keeps the buy button on screen,
   unselected-size state, bottom "Select Your Size" bar (<990px) as an accessible dialog, °C/°F toggle,
   colour-family swap without reload. Every init is torn down (AbortController + unsubscribers) before a swap
   or theme-editor re-render so nothing leaks. */
(function () {
  var DESKTOP = window.matchMedia('(min-width: 990px)');
  var TABLET = window.matchMedia('(min-width: 750px)');
  var instances = new Map(); // section root -> { ac, unsubs }

  function onScrollEnd(el, fn, signal) {
    if ('onscrollend' in window) el.addEventListener('scrollend', fn, { signal: signal });
    else { var t; el.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(fn, 120); }, { passive: true, signal: signal }); }
  }
  function sizeFieldset(scope) {
    var sets = Array.prototype.slice.call(scope.querySelectorAll('[data-sat-size-picker] fieldset'));
    if (!sets.length) return null;
    return sets.find(function (f) { var l = f.querySelector('legend'); return l && /size/i.test(l.textContent); }) || sets[sets.length - 1];
  }

  /* ---------- Carousel (Satisfy slider-loop) ---------- */
  function initSlider(root, signal) {
    var track = root.querySelector('[data-sat-track]');
    if (!track) return null;
    var slides = Array.prototype.slice.call(track.children);
    var n = slides.length;
    var dots = root.querySelectorAll('[data-sat-dots] .sat-slider__dot');
    if (n < 2) return null;
    function clone(li) {
      var c = li.cloneNode(true);
      c.setAttribute('aria-hidden', 'true'); c.removeAttribute('data-media-id'); c.classList.add('is-clone');
      c.querySelectorAll('img').forEach(function (img) { img.loading = 'lazy'; img.removeAttribute('fetchpriority'); });
      return c;
    }
    track.insertBefore(clone(slides[n - 1]), slides[0]);
    track.appendChild(clone(slides[0]));
    var w = function () { return track.clientWidth; };
    var pos = function () { return Math.round(track.scrollLeft / w()); };
    function jump(i) { track.style.scrollSnapType = 'none'; track.scrollTo({ left: i * w(), behavior: 'instant' }); requestAnimationFrame(function () { track.style.scrollSnapType = ''; }); }
    function go(i) { track.scrollTo({ left: i * w(), behavior: 'smooth' }); }
    function paint() {
      var r = (pos() - 1 + n) % n;
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === r); if (k === r) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
    }
    jump(1);
    track.addEventListener('scroll', paint, { passive: true, signal: signal });
    onScrollEnd(track, function () { var p = pos(); if (p === 0) jump(n); else if (p === n + 1) jump(1); paint(); }, signal);
    var prev = root.querySelector('[data-sat-prev]'), next = root.querySelector('[data-sat-next]');
    if (prev) prev.addEventListener('click', function () { go(pos() - 1); }, { signal: signal });
    if (next) next.addEventListener('click', function () { go(pos() + 1); }, { signal: signal });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.index, 10) + 1); }, { signal: signal }); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(pos() - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(pos() + 1); }
    }, { signal: signal });
    var last = 1, lastW = window.innerWidth;
    track.addEventListener('scroll', function () { last = pos(); }, { passive: true, signal: signal });
    // Only re-snap when the width changes (iOS toolbar show/hide fires resize mid-swipe)
    window.addEventListener('resize', function () { if (window.innerWidth === lastW) return; lastW = window.innerWidth; jump(last); }, { signal: signal });
    return { showMedia: function (key) { var i = slides.findIndex(function (s) { return s.dataset.mediaId === key; }); if (i > -1) go(i + 1); } };
  }

  /* ---------- Sticky info (Satisfy product-sticky.js) ---------- */
  function initSticky(pdp, signal) {
    var info = pdp.querySelector('.sat__info-inner'), col = pdp.querySelector('.sat__info');
    if (!info || !col) return;
    var BUTTON_MARGIN = 20, ticking = false;
    function headerVisible() { var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--oest-header-visible')); return isNaN(v) ? 0 : v; }
    function update() {
      ticking = false;
      if (!TABLET.matches) { info.style.top = ''; return; }
      var base = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sat-sticky-top')) || 84;
      // Follow the scroll-linked header, but never push the column below where it naturally sits (aligned with the carousel)
      var top = Math.max(base, Math.min(headerVisible() + 24, col.getBoundingClientRect().top));
      info.style.top = top + 'px';
      var btn = pdp.querySelector('[data-sat-buy] .product-form__submit');
      if (!btn) return;
      var r = btn.getBoundingClientRect(), vh = window.innerHeight;
      if (r.bottom > vh) info.style.top = (top - (r.bottom - vh + BUTTON_MARGIN)) + 'px';
      else if (r.top < 0) info.style.top = (top - r.top) + 'px';
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true, signal: signal });
    window.addEventListener('resize', onScroll, { passive: true, signal: signal });
    update();
  }

  /* ---------- Unselected size on first load ---------- */
  function initUnselected(pdp, signal) {
    var buy = pdp.querySelector('[data-sat-buy]');
    var fs = sizeFieldset(pdp);
    if (!buy || !fs || buy.dataset.available === 'false') return;
    var inputs = fs.querySelectorAll('input[type="radio"]');
    if (!inputs.length || /[?&]variant=/.test(location.search)) return;
    inputs.forEach(function (i) { i.checked = false; });
    setUnselected(buy, true);
    fs.addEventListener('change', function () { setUnselected(buy, false); }, { once: true, signal: signal });
  }
  function setUnselected(buy, on) {
    var btn = buy.querySelector('.product-form__submit'); if (!btn) return;
    var span = btn.querySelector('span') || btn;
    buy.classList.toggle('is-unselected', on); // also hides Buy-it-now so it can't buy the default size
    if (on) {
      if (!btn.dataset.satLabel) btn.dataset.satLabel = span.textContent.trim();
      span.textContent = buy.dataset.unselectedLabel || 'Select Your Size';
      btn.setAttribute('disabled', ''); btn.setAttribute('aria-disabled', 'true'); btn.classList.add('is-unselected');
    } else {
      // Restore the label only; Dawn's product-info decides disabled/"Sold out" after it fetches the variant
      btn.classList.remove('is-unselected'); btn.removeAttribute('aria-disabled');
      if (btn.dataset.satLabel) span.textContent = btn.dataset.satLabel;
    }
  }

  /* ---------- Bottom bar (Satisfy add-to-cart-drawer) as an accessible dialog ---------- */
  function initBar(pdp, signal, unsubs) {
    var root = pdp.closest('.shopify-section') || document;
    var bar = root.querySelector('[data-sat-bar]');
    if (!bar) return;
    var panel = bar.querySelector('.sat-bar__panel');
    var buyWrap = function () { return root.querySelector('[data-sat-buy]'); };
    var sourceBtn = function () { var b = buyWrap(); return b && b.querySelector('.product-form__submit'); };
    var sizesSlot = bar.querySelector('[data-sat-bar-sizes]');
    var buySlot = bar.querySelector('[data-sat-bar-buy]');
    var directSlot = bar.querySelector('[data-sat-bar-buy-direct]');
    var opener = bar.querySelector('[data-sat-bar-open]');
    var observer = null, lockY = null, lastFocus = null;

    function syncBuy(slot) {
      var src = sourceBtn(); if (!src || !slot) return;
      slot.innerHTML = '';
      var c = src.cloneNode(true);
      c.removeAttribute('id'); c.removeAttribute('form'); c.type = 'button';
      c.addEventListener('click', function (e) { e.preventDefault(); if (!src.disabled) src.click(); }, { signal: signal });
      slot.appendChild(c);
    }
    function syncAll() { syncBuy(buySlot); if (directSlot) syncBuy(directSlot); }
    function cloneSizes() {
      var src = sizeFieldset(root); if (!src || !sizesSlot) return;
      sizesSlot.innerHTML = '';
      var c = src.cloneNode(true);
      c.querySelectorAll('input').forEach(function (i) { i.id = 'bar-' + i.id; i.removeAttribute('form'); i.name = 'bar-' + i.name; });
      c.querySelectorAll('label').forEach(function (l) { l.htmlFor = 'bar-' + l.htmlFor; });
      c.querySelectorAll('script, modal-opener').forEach(function (s) { s.remove(); });
      c.addEventListener('change', function (e) {
        var real = sizeFieldset(root) && sizeFieldset(root).querySelector('input[value="' + CSS.escape(e.target.value) + '"]');
        if (real) { real.checked = true; real.dispatchEvent(new Event('change', { bubbles: true })); }
      }, { signal: signal });
      sizesSlot.appendChild(c);
    }
    function focusables() { return Array.prototype.filter.call(panel.querySelectorAll('button, input, a[href], [tabindex]:not([tabindex="-1"])'), function (el) { return el.offsetParent !== null && !el.disabled; }); }
    function sentinel(where) {
      var s = document.createElement('span');
      s.tabIndex = 0; s.className = 'sat-bar__sentinel'; s.setAttribute('aria-hidden', 'true');
      s.addEventListener('focus', function () { var f = focusables().filter(function (el) { return !el.classList.contains('sat-bar__sentinel'); }); if (!f.length) return; (where === 'end' ? f[0] : f[f.length - 1]).focus(); }, { signal: signal });
      return s;
    }
    function open() {
      if (!bar.classList.contains('is-visible') || bar.classList.contains('is-open')) return;
      lastFocus = document.activeElement;
      cloneSizes(); syncAll();
      panel.querySelectorAll('.sat-bar__sentinel').forEach(function (s) { s.remove(); });
      panel.insertBefore(sentinel('start'), panel.firstChild);
      panel.appendChild(sentinel('end'));
      bar.classList.add('is-open');
      panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-modal', 'true');
      panel.setAttribute('aria-label', (bar.dataset.dialogLabel || 'Select your size'));
      document.documentElement.classList.add('sat-bar-lock');
      lockY = window.scrollY;
      var first = sizesSlot.querySelector('input:checked') || sizesSlot.querySelector('input:not(:disabled)') || focusables()[0];
      if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 50);
    }
    function close() {
      if (!bar.classList.contains('is-open')) return;
      bar.classList.remove('is-open');
      panel.querySelectorAll('.sat-bar__sentinel').forEach(function (s) { s.remove(); });
      panel.removeAttribute('role'); panel.removeAttribute('aria-modal'); panel.removeAttribute('aria-label');
      document.documentElement.classList.remove('sat-bar-lock');
      lockY = null;
      var target = (opener && bar.classList.contains('is-visible')) ? opener : (sizeFieldset(root) && sizeFieldset(root).querySelector('input:checked')) || sourceBtn();
      if (lastFocus && document.contains(lastFocus) && lastFocus !== document.body) target = lastFocus;
      if (target) target.focus({ preventScroll: true });
    }
    function visibility() {
      var b = buyWrap(); if (!b) return;
      var br = b.getBoundingClientRect(), pr = pdp.getBoundingClientRect();
      var show = br.bottom < 0 && pr.bottom > 0 && !DESKTOP.matches;
      if (bar.classList.contains('is-visible') !== show) {
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        bar.inert = !show;
        if (!show) close();
      }
    }
    if (opener) opener.addEventListener('click', open, { signal: signal });
    bar.addEventListener('click', function (e) { if (e.target === bar) close(); }, { signal: signal });
    document.addEventListener('keydown', function (e) {
      if (!bar.classList.contains('is-open')) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key === 'Tab' && !panel.contains(document.activeElement)) {
        var f = focusables().filter(function (el) { return !el.classList.contains('sat-bar__sentinel'); });
        if (f.length) { e.preventDefault(); (e.shiftKey ? f[f.length - 1] : f[0]).focus(); }
      }
    }, { signal: signal });
    window.addEventListener('scroll', function () { if (lockY !== null) window.scrollTo(window.scrollX, lockY); requestAnimationFrame(visibility); }, { passive: true, signal: signal });
    window.addEventListener('resize', visibility, { signal: signal });
    if (window.subscribe && window.PUB_SUB_EVENTS) unsubs.push(window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { close(); }));
    var b = buyWrap();
    if (b) { observer = new MutationObserver(syncAll); observer.observe(b, { subtree: true, childList: true, characterData: true, attributes: true }); signal.addEventListener('abort', function () { observer.disconnect(); }); }
    bar.inert = true;
    syncAll(); visibility();
  }

  /* ---------- Norda-style features: name list switches image + description (≥1200), swipe cards below ---------- */
  function initFeatures(pdp, signal) {
    pdp.querySelectorAll('[data-sat-feat]').forEach(function (feat) {
      var tabs = Array.prototype.slice.call(feat.querySelectorAll('.sat-feat__name'));
      function set(i, focus) {
        feat.querySelectorAll('[data-sat-feat-pic]').forEach(function (p) { p.classList.toggle('is-active', +p.dataset.satFeatPic === i); });
        feat.querySelectorAll('.sat-feat__thumb').forEach(function (t) { t.classList.toggle('is-active', +t.dataset.satFeatGo === i); });
        feat.querySelectorAll('[data-sat-feat-desc]').forEach(function (d) { d.hidden = +d.dataset.satFeatDesc !== i; });
        tabs.forEach(function (t, k) { t.setAttribute('aria-selected', k === i ? 'true' : 'false'); t.tabIndex = k === i ? 0 : -1; });
        if (focus && tabs[i]) tabs[i].focus();
        window.dispatchEvent(new Event('scroll')); // refresh reveal overlays on the newly shown image
      }
      feat.querySelectorAll('[data-sat-feat-go]').forEach(function (b) {
        b.addEventListener('click', function () { set(+b.dataset.satFeatGo, false); }, { signal: signal });
      });
      var list = feat.querySelector('[role="tablist"]');
      if (list) list.addEventListener('keydown', function (e) {
        var i = tabs.indexOf(document.activeElement); if (i < 0) return;
        var to = { ArrowDown: i + 1, ArrowRight: i + 1, ArrowUp: i - 1, ArrowLeft: i - 1, Home: 0, End: tabs.length - 1 }[e.key];
        if (to === undefined) return;
        e.preventDefault(); e.stopPropagation();
        set((to + tabs.length) % tabs.length, true);
      }, { signal: signal });
      // Cards: prev/next scroll by one card, buttons disable at the ends
      var track = feat.querySelector('[data-sat-feat-track]');
      var prev = feat.querySelector('[data-sat-feat-prev]'), next = feat.querySelector('[data-sat-feat-next]');
      if (!track || !prev || !next) return;
      function step() { var c = track.querySelector('.sat-feat__card'); return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth; }
      function paint() { prev.disabled = track.scrollLeft <= 2; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; }
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); }, { signal: signal });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); }, { signal: signal });
      track.addEventListener('scroll', paint, { passive: true, signal: signal });
      window.addEventListener('resize', paint, { signal: signal });
      paint();
    });
  }

  /* ---------- Feature videos: muted loops that play only while on screen (no controls). Nothing downloads until a
     video first scrolls into view; visitors who prefer reduced motion get the still poster. ---------- */
  function initVideos(pdp, signal) {
    var vids = pdp.querySelectorAll('[data-sat-video]');
    if (!vids.length || !('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    function load(v) {
      if (v.dataset.loaded) return;
      v.dataset.loaded = 'true';
      var hls = v.dataset.srcHls && v.canPlayType('application/vnd.apple.mpegurl'); // adaptive stream where it plays natively
      v.src = hls ? v.dataset.srcHls : (v.dataset.srcMp4 || v.dataset.srcHls);
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) {
          load(v); v.muted = true;
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) v.pause();
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { v.muted = true; io.observe(v); });
    document.addEventListener('visibilitychange', function () {
      vids.forEach(function (v) { if (document.hidden && !v.paused) v.pause(); });
    }, { signal: signal });
    signal.addEventListener('abort', function () { io.disconnect(); vids.forEach(function (v) { v.pause(); }); });
  }

  /* ---------- Size guide drawer (Satisfy size-guide-drawer): native <dialog>, slides in from the right ---------- */
  var SG_UNIT_KEY = 'oest-size-guide-unit';
  function initSizeGuide(root, signal) {
    var dlg = root.querySelector('[data-sat-sg]');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    var panel = dlg.querySelector('.sat-sg__panel'), lastFocus = null, closeTimer = null;
    function setUnit(u) {
      dlg.querySelectorAll('[data-sat-sg-table]').forEach(function (t) { t.hidden = t.dataset.satSgTable !== u; });
      var sw = dlg.querySelector('[data-sat-sg-units]');
      if (sw) { sw.classList.toggle('is-in', u === 'in'); sw.setAttribute('aria-checked', u === 'in' ? 'true' : 'false'); }
    }
    function open(e) {
      if (dlg.open) return;
      clearTimeout(closeTimer); dlg.classList.remove('is-closing');
      // Return focus to the link that opened it (Safari doesn't focus buttons on click)
      lastFocus = (e && e.currentTarget) || document.activeElement;
      dlg.showModal();
      dlg.scrollLeft = 0; dlg.scrollTop = 0; // never let focus scroll the off-screen panel into view
      document.documentElement.classList.add('sat-sg-lock');
      panel.focus({ preventScroll: true });
      requestAnimationFrame(function () { requestAnimationFrame(function () { dlg.classList.add('is-open'); }); });
    }
    function close() {
      if (!dlg.open || dlg.classList.contains('is-closing')) return;
      dlg.classList.remove('is-open'); dlg.classList.add('is-closing');
      var done = function () { clearTimeout(closeTimer); if (!dlg.classList.contains('is-closing')) return; dlg.classList.remove('is-closing'); dlg.close(); };
      panel.addEventListener('transitionend', done, { once: true, signal: signal });
      closeTimer = setTimeout(done, 350); // reduced motion / no transition
    }
    root.querySelectorAll('[data-sat-sg-open]').forEach(function (b) { b.addEventListener('click', open, { signal: signal }); });
    dlg.querySelectorAll('[data-sat-sg-close]').forEach(function (b) { b.addEventListener('click', close, { signal: signal }); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); }, { signal: signal }); // the dimmed area
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); }, { signal: signal }); // Esc slides out too
    dlg.addEventListener('close', function () {
      document.documentElement.classList.remove('sat-sg-lock');
      if (lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
    }, { signal: signal });
    var sw = dlg.querySelector('[data-sat-sg-units]');
    if (sw) sw.addEventListener('click', function () {
      var u = sw.classList.contains('is-in') ? 'cm' : 'in';
      setUnit(u);
      try { localStorage.setItem(SG_UNIT_KEY, u); } catch (e) {}
    }, { signal: signal });
    var saved = null; try { saved = localStorage.getItem(SG_UNIT_KEY); } catch (e) {}
    if (saved === 'in') setUnit('in');
    signal.addEventListener('abort', function () { clearTimeout(closeTimer); if (dlg.open) dlg.close(); document.documentElement.classList.remove('sat-sg-lock'); });
  }

  /* ---------- Temperature unit toggle ---------- */
  function initTemp(pdp, signal) {
    pdp.querySelectorAll('[data-sat-temp]').forEach(function (t) {
      t.querySelectorAll('[data-sat-unit]').forEach(function (b) {
        b.addEventListener('click', function () {
          var u = b.dataset.satUnit;
          t.querySelectorAll('[data-sat-unit]').forEach(function (x) { x.classList.toggle('is-active', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          t.querySelectorAll('[data-sat-unit-labels]').forEach(function (l) { l.hidden = l.dataset.satUnitLabels !== u; });
        }, { signal: signal });
      });
    });
  }

  /* ---------- Scroll highlight (Norda c-text-reveal): split statements into characters, light them up with scroll ---------- */
  function initHighlight(pdp, signal) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var dim = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sat-hl-dim'));
    if (isNaN(dim)) dim = 0.25;
    if (dim >= 0.99) return;
    var items = [];
    pdp.querySelectorAll('[data-sat-highlight]').forEach(function (el) {
      if (!el.dataset.satSplit) {
        el.dataset.satSplit = 'true';
        el.setAttribute('aria-label', el.textContent.replace(/\s+/g, ' ').trim());
        var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
        var nodes = []; while (walker.nextNode()) nodes.push(walker.currentNode);
        nodes.forEach(function (node) {
          if (!node.textContent.trim()) return;
          var frag = document.createDocumentFragment();
          node.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
            var word = document.createElement('span'); word.className = 'sat-hl-word'; word.setAttribute('aria-hidden', 'true');
            Array.from(part).forEach(function (ch) { var s = document.createElement('span'); s.className = 'sat-hl-char'; s.textContent = ch; word.appendChild(s); });
            frag.appendChild(word);
          });
          node.parentNode.replaceChild(frag, node);
        });
      }
      items.push({ el: el, chars: Array.prototype.slice.call(el.querySelectorAll('.sat-hl-char')) });
    });
    if (!items.length) return;
    var EDGE = 4, ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight;
      items.forEach(function (it) {
        var r = it.el.getBoundingClientRect();
        if (r.width === 0) return; // hidden copy (desktop vs mobile story)
        // Starts lighting when the text's top reaches 75% down the screen, finishes when its bottom passes 45%
        var p = (0.75 * vh - r.top) / (0.3 * vh + r.height);
        p = Math.max(0, Math.min(1, p));
        var n = it.chars.length, head = p * (n + EDGE);
        for (var i = 0; i < n; i++) {
          var k = Math.max(0, Math.min(1, (head - i) / EDGE));
          it.chars[i].style.opacity = (dim + (1 - dim) * k).toFixed(3);
        }
      });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true, signal: signal });
    window.addEventListener('resize', onScroll, { passive: true, signal: signal });
    update();
  }

  /* ---------- Reveal images: dark/glow shot fades in as the image moves up the screen ---------- */
  function initReveal(pdp, signal) {
    var els = pdp.querySelectorAll('[data-sat-reveal]');
    if (!els.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches, ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.width === 0) return;
        // Fades in while the image's centre moves from 75% to 40% down the screen
        var center = r.top + r.height / 2;
        var p = (0.75 * vh - center) / (0.35 * vh);
        p = Math.max(0, Math.min(1, p));
        el.style.setProperty('--reveal', reduce ? (p > 0.5 ? 1 : 0) : p.toFixed(3));
      });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true, signal: signal });
    window.addEventListener('resize', onScroll, { passive: true, signal: signal });
    update();
  }

  /* ---------- Colour family swap ---------- */
  var swapCache = new Map();
  function sectionIdOf(root) { var pi = root.querySelector('product-info'); return pi && pi.dataset.section; }
  function viewParam() { var m = location.search.match(/[?&]view=([^&]+)/); return m ? m[1] : null; }
  function withView(url) { var v = viewParam(); if (!v || /[?&]view=/.test(url)) return url; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'view=' + v; }
  function selectedTitle(root) {
    var fs = sizeFieldset(root), checked = fs && fs.querySelector('input:checked');
    if (!checked) return null;
    var label = root.querySelector('label[for="' + checked.id + '"]');
    return label ? label.textContent.replace(/Variant sold out or unavailable/i, '').trim() : checked.value;
  }
  function targetUrl(tile, root) {
    var url = tile.dataset.productUrl, map = {};
    try { map = JSON.parse(tile.dataset.variants || '{}'); } catch (e) {}
    var t = selectedTitle(root), vid = t && map[t];
    return withView(vid ? url + '?variant=' + vid : url);
  }
  function fetchSection(url, sid) {
    var req = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sid);
    if (!swapCache.has(req)) {
      swapCache.set(req, fetch(req, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .catch(function (err) { swapCache.delete(req); throw err; }));
    }
    return swapCache.get(req);
  }
  function scrollToTop() {
    var start = window.scrollY; if (start <= 0) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { window.scrollTo(0, 0); return; }
    var dur = Math.min(450, 250 + start / 20), t0 = performance.now();
    (function frame(now) { var p = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - p, 3); window.scrollTo(0, Math.round(start * (1 - e))); if (p < 1) requestAnimationFrame(frame); })(t0);
  }
  var swapSeq = 0;
  function swapTo(url, root, push) {
    var sid = sectionIdOf(root);
    if (!sid) { window.location.href = url; return; }
    var seq = ++swapSeq; // two quick swatch clicks: only the latest one may render
    root.classList.add('sat-swapping');
    return fetchSection(url, sid).then(function (text) {
      if (seq !== swapSeq) return;
      var doc = new DOMParser().parseFromString(text, 'text/html');
      var fresh = doc.getElementById('shopify-section-' + sid) || doc.querySelector('.shopify-section');
      if (!fresh) throw new Error('missing');
      teardown(root);
      root.innerHTML = fresh.innerHTML;
      var pi = root.querySelector('product-info');
      if (pi && pi.dataset.oestTitle) document.title = pi.dataset.oestTitle.replace(/&ndash;/g, '–');
      if (push) history.pushState({ satSwap: true }, '', url);
      initAll(root);
    }).catch(function () { if (seq === swapSeq) window.location.href = url; })
      .finally(function () { if (seq === swapSeq) root.classList.remove('sat-swapping'); });
  }
  function initColors(root, signal) {
    root.querySelectorAll('[data-oest-colors] [data-oest-color]').forEach(function (tile) {
      var prefetch = function () { if (tile.classList.contains('is-active')) return; var sid = sectionIdOf(root); if (sid) fetchSection(targetUrl(tile, root), sid).catch(function () {}); };
      tile.addEventListener('pointerenter', prefetch, { passive: true, signal: signal });
      tile.addEventListener('focus', prefetch, { signal: signal });
      tile.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        e.preventDefault();
        if (tile.classList.contains('is-active')) return;
        scrollToTop();
        swapTo(targetUrl(tile, root), root, true);
      }, { signal: signal });
    });
  }

  /* ---------- Lifecycle ---------- */
  function teardown(root) {
    var inst = instances.get(root);
    if (!inst) return;
    inst.ac.abort();
    inst.unsubs.forEach(function (u) { if (typeof u === 'function') u(); });
    document.documentElement.classList.remove('sat-bar-lock');
    instances.delete(root);
  }
  function initAll(root) {
    var pdp = root.querySelector('[data-sat-pdp]');
    if (!pdp) return;
    teardown(root);
    var ac = new AbortController(), unsubs = [];
    instances.set(root, { ac: ac, unsubs: unsubs });
    var signal = ac.signal;
    var sliderEl = pdp.querySelector('[data-sat-slider]');
    var slider = sliderEl ? initSlider(sliderEl, signal) : null;
    initUnselected(pdp, signal);
    initSticky(pdp, signal);
    initTemp(pdp, signal);
    initHighlight(pdp, signal);
    initReveal(pdp, signal);
    initColors(root, signal);
    initBar(pdp, signal, unsubs);
    initSizeGuide(root, signal);
    initVideos(pdp, signal);
    initFeatures(pdp, signal);
    if (slider && window.subscribe && window.PUB_SUB_EVENTS) {
      unsubs.push(window.subscribe(window.PUB_SUB_EVENTS.variantChange, function (ev) {
        var v = ev && ev.data && ev.data.variant;
        if (!v || !v.featured_media || !document.contains(pdp)) return;
        slider.showMedia(pdp.dataset.section + '-' + v.featured_media.id);
      }));
    }
  }
  var popBound = false;
  function init() {
    document.querySelectorAll('[data-sat-pdp]').forEach(function (pdp) {
      var root = pdp.closest('.shopify-section');
      if (root) initAll(root);
    });
    if (!popBound) {
      popBound = true;
      history.replaceState({ satSwap: true }, '', location.href);
      window.addEventListener('popstate', function () {
        instances.forEach(function (_, root) {
          var pi = root.querySelector('product-info');
          if (pi && pi.dataset.url && pi.dataset.url !== location.pathname) swapTo(location.pathname + location.search, root, false);
        });
      });
      // Theme editor re-renders the section after every edit
      document.addEventListener('shopify:section:load', function (e) { if (e.target && e.target.querySelector('[data-sat-pdp]')) initAll(e.target); });
      document.addEventListener('shopify:section:unload', function (e) { if (e.target) teardown(e.target); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
